import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router';

import { Surface } from '@/Surface';

import '@/index.css';

/**
 * Entry point of the backoffice.
 *
 * Client rendered on purpose: unlike the participant frontend this is a small,
 * authenticated tool behind a login, it takes no public load spike and it is
 * never cached (ADR 0001).
 *
 * Every screen reads through the generated OpenAPI client (`@/lib/api`). The
 * sentence that stood here described the scaffold, which rendered
 * `src/mock/backoffice-data.ts`, a file that no longer exists. A comment
 * claiming an application shows invented data is worse than no comment: it is
 * the first thing somebody reads before deciding whether to trust a number.
 *
 * A data router, so the save bar can hold a navigation while changes are unsaved
 * (`useBlocker`). One splat route: the screens keep their own `<Routes>` below it.
 */
const container = document.getElementById('root');

if (container === null) {
  // Internal wording: this can only ever be a build/deployment error.
  throw new Error('[main] Root element #root not found in index.html');
}

const router = createBrowserRouter([{ path: '*', element: <Surface /> }]);

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
